<div class="signin-container">
  <div class="signin-card">
    <div class="card-icon">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M12 2v6m0 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-4 9v5m8-5v5m-8 0a3 3 0 1 0-6 0m20 0a3 3 0 1 1-6 0"/>
      </svg>
    </div>
    <h1>{{ 'signin.title' | t }}</h1>
    <p class="subtitle">{{ 'signin.subtitle' | t }}</p>

    @if (facebookError) {
      <p class="form-error">{{ facebookError }}</p>
    }

    <form [formGroup]="signinForm" (ngSubmit)="onAuthenticate()">
      <mat-form-field appearance="outline" class="input">
        <mat-label>{{ 'signin.email' | t }}</mat-label>
        <input matInput type="email" [formControl]="emailFormControl">
        @if (emailFormControl.hasError('email') && !emailFormControl.hasError('required')) {
          <mat-error>{{ 'signin.emailInvalid' | t }}</mat-error>
        }
        @if (emailFormControl.hasError('required')) {
          <mat-error>{{ 'signin.emailRequired' | t }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="input">
        <mat-label>{{ 'signin.password' | t }}</mat-label>
        <input matInput type="password" [formControl]="passwordFormControl">
        @if (passwordFormControl.hasError('required')) {
          <mat-error>{{ 'signin.passwordRequired' | t }}</mat-error>
        }
      </mat-form-field>
      <button mat-raised-button color="primary" class="signin-button" type="submit"
        [disabled]="emailFormControl.invalid || passwordFormControl.invalid">{{ 'header.signIn' | t }}</button>
    </form>

    @if (facebookAvailable) {
      <div class="separator"><span>{{ 'signin.or' | t }}</span></div>
      <button mat-stroked-button class="facebook-button" (click)="onAuthenticateFacebook()">
        {{ 'signin.facebook' | t }}
      </button>
    }

    <a class="back-link" routerLink="/">{{ 'signin.backHome' | t }}</a>
  </div>
</div>
